module.exports = "https://cdn.realtymogul.com/static/media/Img_card_REITs.11c2d45a.jpg";